import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';
import '../splash/Splash.css';

function ErrorPage() {
  const navigate = useNavigate();
  const goHome = () => navigate('/');

  return (
    <div className="splash padding flex flex-col items-center">
      <div className="width-fit flex flex-col items-center gap-small">
        <h2 className="flex flex-col items-center">
          <span className="splash-header">Oops!</span>
          <span className="splash-subtitle">Something went wrong.</span>
        </h2>

        <Button
          className="splash-button"
          style={{ border: 'none' }}
          variant="outlined"
          size="large"
          fullWidth
          onClick={goHome}
        >
          Go home
        </Button>
      </div>
    </div>
  );
}

export default ErrorPage;
